import { publicEnv } from './env';
import type { BlueMapServerInput } from './schema';

/**
 * BlueMap's default webserver port.
 *
 * Used as a development fallback when no origin is configured, so the site boots
 * and renders its "BlueMap unreachable" state against a local instance rather
 * than failing validation on a missing required field. Production deployments set
 * `PUBLIC_BLUEMAP_BASE_URL` and never see this value.
 */
export const DEVELOPMENT_BLUEMAP_ORIGIN = 'http://localhost:8100';

/**
 * The BlueMap instances this site can draw from.
 *
 * Maps reference a server by `id`, so an origin appears exactly once. Adding a
 * second, third or tenth BlueMap host means adding an entry here, no component
 * changes, and no per-map URL duplication.
 */
export const servers: BlueMapServerInput[] = [
	{
		id: 'main',
		name: 'Citrus Meadow',
		description: 'The Citrus Meadow network.',
		baseUrl: publicEnv.bluemapBaseUrl ?? DEVELOPMENT_BLUEMAP_ORIGIN,
		/** Exactly one server should be marked default; it backs maps that name none. */
		default: true
	}
];
